import { ViewModelBase } from "./viewmodelbase";
import { ResponseContainer } from "../Models/responsecontainer";
import { ToastNotification, ToastNotificationKind } from "./toastnotification";
import { observable } from "knockout";

class DialogViewModel {
    constructor(public id: string, public title: string, public content: string, public actions: DialogAction[]) {
        $.each(this.actions,
            (index: number, action: DialogAction) => {
                action.parent = this;
            });
    }
    public isBusy = ko.observable<boolean>(false);
    public onBeforeShowModal: (dialogElement: HTMLElement) => void;
    public close() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement != null) {
            dialogElement.close();
        }
        $(`#dialog-${this.id}`).remove();
    }

    public hide() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement != null) {
            $(dialogElement).hide();
        }
    }

    public show() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement != null) {
            $(dialogElement).show();
        }
    }

    public disableActions() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement != null) {
            $(dialogElement).find('.mdl-dialog__actions button').prop('disabled', true);
        }
    }

    public enableActions() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement != null) {
            $(dialogElement).find('.mdl-dialog__actions button').prop('disabled', false);
        }
    }

    public showNotification(notification: ToastNotification): void {
        notification.show();
    }

    public setFocus(selector: string): void {
        setTimeout(() => {
            var $element = $(`#dialog-${this.id} ${selector}`);
            if ($element.length > 0) {
                $element.prop('disabled', false).trigger('focus');
                $element.closest('div').addClass("is-focused").removeClass('is-disabled');
            }
        }, 1);
    }

    /**
     * Fetch json data
     */
    // tslint:disable-next-line
    protected getJsonData<T>(url: string, success: (data: T) => void, error?: JQuery.Ajax.ErrorCallback<any>, complete?: JQuery.Ajax.CompleteCallback<any>) {
        var call = $.getJSON(url, (response: ResponseContainer) => {
            if (success != null) {
                success(response.value as T);
            }
        });
        if (error) {
            call.fail(error);
        }
        if (complete) {
            call.always(complete);
        }
    }

    public setNarrowView() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement !== null) {
            $(dialogElement).addClass("mdl-dialog-narrowwide");
        }
    }

    public setWideView() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement !== null) {
            $(dialogElement).addClass("mdl-dialog-extrawide");
        }
    }

    public setAltraWideView() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement !== null) {
            $(dialogElement).addClass("mdl-dialog-altrawide");
        }
    }

    public setFullHeightView() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement !== null) {
            $(dialogElement).addClass("mdl-dialog-fullheight");
        }
    }

    public setScrollableContent() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement !== null) {
            $(dialogElement).addClass("mdl-dialog-scrollable-content");
        }
    }

}

class DialogAction {
    public caption = observable<string>(null);
    constructor(public initialCaption: string, public actionHandler: () => boolean, public isClose: boolean = false) {
        this.caption(initialCaption);
    }
    public parent: DialogViewModel;
    public action(): void {
        if (!this.actionHandler()) {
            if (this.isClose) {
                this.parent.close();
            }
        }
    }
}

export { DialogAction, DialogViewModel };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/ViewModels/dialogviewmodel.ts